import { numConvert, calculation } from "@/method";
import Echarts from "echarts";
import _ from 'lodash';

const color = ['#7079df', '#d15b7f', '#fb6e6c', '#ff9f69', '#feb64d', '#ffda43', '#ffe88e'];

export default ({
    data = [],
    last = [],
    area = [],
    arealast = [],
    interval = [],
    intervallast = [],
    areaLen = 1,
    intervalLen = 1,
}, day) => {

    return {
        data: compute({ data, day }),
        last: compute({ data: last, day }),
        area: compute({ data: area, day, length: areaLen }),
        arealast: compute({ data: arealast, day, length: areaLen }),
        interval: compute({ data: interval, day, length: intervalLen }),
        intervallast: compute({ data: intervallast, day, length: intervalLen }),
    }
}

export function compute({
    totalFee1, totalFee2_3, roomFee1, roomFee2_3,
    foodFee1, foodFee2_3, elseFee1, elseFee2_3, data7_7, data7_1
}, data) {
    data[0].diff = (numConvert(totalFee1) - numConvert(totalFee2_3)).toFixed(2);
    data[0].rat = calculation(numConvert(totalFee1) - numConvert(totalFee2_3), totalFee2_3, 4);

    data[2].diff = (numConvert(roomFee1) - numConvert(roomFee2_3)).toFixed(2);
    data[2].rat = calculation(numConvert(roomFee1) - numConvert(roomFee2_3), roomFee2_3, 4);
    data[5].diff = (numConvert(foodFee1) - numConvert(foodFee2_3)).toFixed(2);
    data[5].rat = calculation(numConvert(foodFee1) - numConvert(foodFee2_3), foodFee2_3, 4)
    data[8].diff = (numConvert(elseFee1) - numConvert(elseFee2_3)).toFixed(2)
    data[8].rat = calculation(numConvert(elseFee1) - numConvert(elseFee2_3), elseFee2_3, 4)
    data[1].diff = (numConvert(_.get(data7_1, '16.thisy_payroll_cost')) + numConvert(_.get(data7_1, '19.thisy_payroll_cost')) - numConvert(_.get(data7_1, '16.lasty_payroll_cost')) - numConvert(_.get(data7_1, '19.lasty_payroll_cost'))).toFixed(2)
    data[3].diff = (numConvert(_.get(data7_7, '6.actual')) + numConvert(_.get(data7_1, '18.thisy_payroll_cost')) - numConvert(_.get(data7_7, '6.last')) - numConvert(_.get(data7_1, '18.lasty_payroll_cost'))).toFixed(2)
    data[4].diff = (numConvert(_.get(data7_1, '18.thisy_payroll_cost')) - numConvert(_.get(data7_1, '18.lasty_payroll_cost'))).toFixed(2)
    data[6].diff = (numConvert(_.get(data7_7, '10.actual')) + numConvert(_.get(data7_1, '17.thisy_payroll_cost')) - numConvert(_.get(data7_7, '10.last')) - numConvert(_.get(data7_1, '17.lasty_payroll_cost'))).toFixed(2)
    data[7].diff = (numConvert(_.get(data7_1, '17.thisy_payroll_cost')) - numConvert(_.get(data7_1, '17.lasty_payroll_cost'))).toFixed(2)
    data[9].diff = (numConvert(_.get(data7_7, '14.actual')) - numConvert(_.get(data7_7, '14.last'))).toFixed(2)

    data[1].rat = calculation(data[1].diff, numConvert(_.get(data7_1, '16.lasty_payroll_cost')) + numConvert(_.get(data7_1, '19.lasty_payroll_cost')), 4);
    data[3].rat = calculation(data[3].diff, numConvert(_.get(data7_7, '6.last')) + numConvert(_.get(data7_1, '18.lasty_payroll_cost')), 4)
    data[4].rat = calculation(data[4].diff, numConvert(_.get(data7_1, '18.lasty_payroll_cost')), 4);
    data[6].rat = calculation(data[6].diff, numConvert(_.get(data7_7, '10.last')) + numConvert(_.get(data7_1, '17.lasty_payroll_cost')), 4);
    data[7].rat = calculation(data[7].diff, numConvert(_.get(data7_1, '17.lasty_payroll_cost')), 4);
    data[9].rat = calculation(data[9].diff, numConvert(_.get(data7_7, '14.last')), 4);
    return data;
}

export const setKarte = ({
    dataY, title
}, isOnResize) => {
    const myChart = Echarts.init(document.getElementById("chart"));
    myChart.resize();
    if (isOnResize) {
        return
    }
    const option = {
        color,
        title: {
            text: title,
            textStyle: {
                fontSize: 20
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' },
        },
        grid: {
            top: 120,
        },
        legend: {
            top: 30,
            data: dataY.map(x => x.name),
            textStyle: {
                fontSize: 18
            },
            // selected: dataY.reduce((a, b) => ({ ...a, [b.name]: false }), {}),
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    show: true
                }
            }
        },
        xAxis: [
            {
                type: 'category',
                axisLabel: {
                    color: "black",
                    fontSize: 14,
                },
                data: new Array(12).fill(1).map((x, i) => `${i + 1}月`)
            }
        ],
        yAxis: {
            type: 'value',
            name: '',
            axisLabel: {
                formatter: "{value}%"
            },

        },
        series: dataY.map((x, i) => {
            return {
                name: x.name,
                type: "line",
                smooth: true,
                data: x.data.map(x => (x * 100).toFixed(1))
            }
        }),
    }

    myChart.setOption(option, true);
}


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-1TotalPayrollCostAnalysis/7-1-3/compute.js